import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M4.6 5.4h1.6M4.6 7.8h5.2M4.6 10.2h5.2M2.2 11.4V3a1.6 1.6 0 0 1 1.6-1.6h4.469c.212 0 .416.084.565.234l3.132 3.132a.8.8 0 0 1 .234.565V11.4a1.6 1.6 0 0 1-1.6 1.6H3.8a1.6 1.6 0 0 1-1.6-1.6"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M12.128 5H9.4a.8.8 0 0 1-.8-.8V1.482"
    }, null, -1)
  ]))]))
}
export default { render: render }